import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { Area } from '../../schema/area';

interface AreaFromInputProps {
  required?: boolean;
  value?: number | null;
  onChange?: (value: number | null) => void;
}

const AreaFromInput: React.FC<AreaFromInputProps> = ({
  required,
  value,
  onChange
}: AreaFromInputProps) => {
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [areaList, setAreaList] = useState<Area[]>([]);
  const [selectedValue, setSelectedValue] = useState<Area | null>(null);

  useEffect(() => {
    if (value != null) {
      const area = areaList.find((data) => data.id == value);
      if (area) {
        setSelectedValue(area);
        return;
      }
      api.get<Area>(`/area/${value}`).then((res) => {
        const { data } = res;
        setSelectedValue(data);
        setAreaList([data]);
      });
    } else {
      api.get<Area[]>(`/area`).then((res) => {
        const { data } = res;
        setAreaList(data);
      });
      setSelectedValue(null);
    }
  }, [value]);

  useEffect(() => {
    if (searchKeyword) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('name', searchKeyword);
        // searchParams.set('limit', '10');

        api.get<Area[]>(`/area`, { params: searchParams }).then((res) => {
          const { data } = res;
          setAreaList(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    }
  }, [searchKeyword]);
  return (
    <Autocomplete
      options={areaList}
      getOptionLabel={(option) => (option?.area_name ? option.area_name : '')}
      renderInput={(params) => (
        <TextField {...params} label="พื่นที่" required={required} placeholder="พื่นที่" />
      )}
      onChange={(_, value) => onChange && onChange(value ? value.id : null)}
      value={selectedValue}
      onInputChange={(_, newInputValue) => {
        setSearchKeyword(newInputValue);
      }}
      isOptionEqualToValue={(option, v) => v?.id == option?.id}
      fullWidth
    />
  );
};

export default AreaFromInput;
